import { baseUrl } from 'volto-ebc-radionacional/utils/api';

export type PodcastProgramFilter = {
  title: string;
  token: string;
};

export function normalizePodcastPrograms(
  data: unknown,
): PodcastProgramFilter[] {
  const items = Array.isArray(data) ? data : [];

  return [
    { title: 'Todos', token: 'Todos' },
    ...items.map((item: any) => ({
      title: item?.title ?? '',
      token: item?.token ?? '',
    })),
  ].filter((item) => item.title && item.token);
}

export async function getPodcastPrograms(): Promise<PodcastProgramFilter[]> {
  try {
    const response = await fetch(
      `${baseUrl}/@programs-schedule?has_podcast=true`,
    );

    if (!response.ok) {
      throw new Error(
        `Erro ao buscar programas: ${response.status} ${response.statusText}`,
      );
    }

    const data = await response.json();
    return normalizePodcastPrograms(data);
  } catch (error) {
    console.error('Falha ao buscar filtros de programas:', error);
    return [{ title: 'Todos', token: 'Todos' }];
  }
}
